import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  header: {
    boxShadow: "0px 0px 0px 0px",
    padding: ".5rem 3rem",
  },
  logo: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  shortLogo: {
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  register: {
    border: `2px solid ${theme.palette.secondary.main}`,
    textTransform: "capitalize",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    fontWeight: "600",
    fontSize: "14px",
    padding: "1rem 1.6rem",
    width: "12rem",
    marginRight: "1rem",
    "&:hover": {
      background: theme.palette.background.hover,
      color:"white",
      border: `2px solid ${theme.palette.secondary.main}`,
    },
  },
  walletButton: {
    borderRadius: "11px",
    border: `2px solid ${theme.palette.secondary.main}`,
    textTransform: "capitalize",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    fontWeight: "600",
    fontSize: "1.4rem",
    padding: "1rem 1.6rem",
    width: "18rem",
    overflow: "hidden",
    "&:hover": {
      background: theme.palette.background.hover,
      // border: `2px solid ${theme.palette.background.hover}`,
    },
  },

  // FOR MODAL
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
    borderRadius: "8px",
    padding: "2.5rem",
  },

  cross: {
    cursor: "pointer",
  },
}));
